/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import dayjs from "dayjs";
import classNames from "clsx";

import Collapse from "react-bootstrap/Collapse";
import Badge from "react-bootstrap/Badge";
import Spinner from "react-bootstrap/Spinner";

import { MdExpandLess, MdExpandMore } from "react-icons/md";

import { useApi } from "@/hooks/useApi";
import { useThemeClassNames } from "@/hooks/useThemeClassNames";

import { transformData } from "@/utils/transformData";
import { hospitalizationPermitMap } from "@/utils/mappings/hospitalizationPermit";

import { ProceduresTable } from "@/components/ProceduresTable";
import { ReportCardAndHistoricTabs } from "@/components/HospitalizationPermits/ReportCardAndHistoricTabs";

import icon from "@/assets/images/printout.svg";

import "./styles.scss";

export function Historic() {
	const { id } = useParams();
	const { api } = useApi();

	const { border, background } = useThemeClassNames();

	const [open, setOpen] = useState(false);

	const [hospitalizationPermits, setHospitalizationPermits] = useState<HospitalizationPermit[]>(
		[]
	);

	const [loading, setLoading] = useState(true);

	async function handleFetchHospitalizationPermits() {
		try {
			const { data } = await api.get(`/hospitalization-permits/historic/${id}`);

			const transformedHospitalizationPermits = transformData<HospitalizationPermit[]>(
				data,
				hospitalizationPermitMap
			);

			setHospitalizationPermits(transformedHospitalizationPermits);
			setLoading(false);
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		handleFetchHospitalizationPermits();
	}, []);

	function formatDate(birthdate: string) {
		if (birthdate) {
			return dayjs(birthdate).format("DD/MM/YYYY");
		}

		return;
	}

	function formatIcd(icd: Idc) {
		if (icd) {
			return `${icd.code} - ${icd.description}`;
		}

		return;
	}

	return (
		<>
			<ReportCardAndHistoricTabs />

			{loading ? (
				<div className="h-200px w-100 d-flex justify-content-center align-items-center">
					<Spinner animation="border" variant="primary" />
				</div>
			) : (
				hospitalizationPermits.map((hospitalizationPermit) => (
					<div
						key={hospitalizationPermit.id}
						className={classNames("rounded my-5", border)}
					>
						<div className={classNames("px-5 py-4", background)}>
							<div className="d-flex gap-1">
								<div className="fs-7">
									<span className="fw-bold">Nº da AIH: </span>
									{hospitalizationPermit?.number}
								</div>
							</div>
						</div>

						<div className="flex-responsive d-flex px-5 py-4 mb-2">
							<div className="col-xl-4 d-flex flex-column gap-2 px-2 mb-2">
								<div className="fs-7">
									<span className="fw-bold">Nome do Paciente: </span>
									{hospitalizationPermit.attendance.patient?.name}
								</div>

								<div className="fs-7">
									<span className="fw-bold">Data da internação: </span>
									{formatDate(
										hospitalizationPermit.attendance.internment
											?.dateTimeAdmission
									)}
								</div>

								<div className="fs-7">
									<span className="fw-bold">Médico Solicitante: </span>
									{hospitalizationPermit.solicitor?.name}
								</div>
							</div>

							<div className="col-xl-7 d-flex flex-column gap-2 px-2 mb-2">
								<div className="flex-responsive d-flex">
									<div className="container-birthdate fs-7">
										<span className="fw-bold">Data de Nascimento: </span>
										{formatDate(
											hospitalizationPermit.attendance.patient?.birthdate
										)}
									</div>

									<div className="container-status-and-tag ms-4 flex-responsive d-flex gap-4">
										<div className="container-status d-flex gap-1">
											<div className="fs-7">
												<span className="fw-bold">Status: </span>
												<Badge className="bg-warning">Pendente</Badge>
											</div>
										</div>

										<div className="container-tag d-flex gap-1">
											<div className="fs-7">
												<span className="fw-bold">Tag: </span>
												<Badge className="bg-danger">Pendente</Badge>
											</div>
										</div>
									</div>
								</div>

								<div className="fs-7">
									<span className="fw-bold">Cid 10 Principal: </span>
									{formatIcd(hospitalizationPermit.icd)}
								</div>

								<div className="fs-7">
									<span className="fw-bold">Médico Auditor: </span>
									{hospitalizationPermit?.medicalAuditor}
								</div>
							</div>

							<div className="col-xl-1 flex-responsive d-flex justify-content-around">
								<img
									alt="Impressão"
									src={icon}
									className="h-25px align-self-start"
								/>

								<span
									className="cursor-pointer fs-2"
									aria-expanded={open}
									onClick={() => setOpen(!open)}
								>
									{open ? <MdExpandLess /> : <MdExpandMore />}
								</span>
							</div>
						</div>

						<Collapse in={open}>
							<div id="collapse-procedures">
								<div className="d-flex justify-content-center">
									<div className="w-100 table-responsive px-5">
										<ProceduresTable
											procedures={hospitalizationPermit.procedures}
										/>
									</div>
								</div>
							</div>
						</Collapse>
					</div>
				))
			)}
		</>
	);
}
